/**
 * Converts a Base64 (without data URL prefix) into a data URL string.
 * Defaults to JPEG if no mime type provided.
 */
export function base64ToDataUrl(base64: string | null | undefined, mime: string = 'image/jpeg'): string | null {
  if (!base64) return null;
  // Strip potential data URL prefix defensively
  const commaIdx = base64.indexOf(',');
  const raw = base64.startsWith('data:') && commaIdx >= 0 ? base64.substring(commaIdx + 1) : base64;
  return `data:${mime};base64,${raw}`;
}

